<template>
  <div></div>
</template>

<script>
// import LogRocket from 'logrocket';
export default {
  mounted() {
    var oParams = this.getUrlParams();

    // 이메일이 '%16진수코드값'으로 들어오므로 변환 후에 파라미터로 사용해야 함
    var params = {
      idx: Number(oParams.idx),
      userEmail: unescape(oParams.email),
    };

    // 웹취약점
    var params = new URLSearchParams();

    params.append("idx", Number(oParams.idx));
    params.append("userEmail", unescape(oParams.email));

    // this.axios.get(this.axios.root + this.axios.port + '/login/carrot-login', {
    //         params: params
    //     })
    this.axios
      .post(this.axios.root + this.axios.port + "/login/carrot-login", params)
      .then((res) => {
        console.log("res", res);
        if (res.data.err === 0) {
          localStorage.setItem("accessToken", res.data.accessToken);

          localStorage.setItem("adminId", res.data.userId);
          localStorage.setItem("regid", oParams.idx);
          this.axios.defaults.headers.common["accessToken"] =
            res.data.accessToken;

          if (oParams?.pageIndex) {
            this.$router.push(
              `/admin/list/main?pageIndex=${oParams.pageIndex}`
            );
          } else {
            this.$router.push("/admin/list/main");
          }
        } else {
          alert("당근농장 어드민 연동 오류, 관리자에게 문의하세요.");
          this.$router.push("/admin/login");
        }
      })
      .catch((res) => {
        alert("당근농장 어드민 연동 오류, 관리자에게 문의하세요.");
        this.$router.push("/admin/login");
      });
  },

  methods: {
    getUrlParams() {
      var params = {};
      window.location.search.replace(
        /[?&]+([^=&]+)=([^&]*)/gi,
        function (str, key, value) {
          params[key] = value;
        }
      );
      return params;
    },
  },
};
</script>
